import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AddSizeUomMutationVariables = Types.Exact<{
  input: Types.AddSizeUomInput;
}>;


export type AddSizeUomMutation = { __typename?: 'Mutation', addSizeUom: { __typename?: 'SizeUomPayload', sizeUom?: { __typename?: 'SizeUomStateData', code: string, description: string, eachesPerUnit: number, status: Types.SizeUomStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateSizeUomMutationVariables = Types.Exact<{
  input: Types.UpdateSizeUomInput;
}>;


export type UpdateSizeUomMutation = { __typename?: 'Mutation', updateSizeUom: { __typename?: 'SizeUomPayload', sizeUom?: { __typename?: 'SizeUomStateData', code: string, description: string, eachesPerUnit: number, status: Types.SizeUomStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ActivateSizeUomMutationVariables = Types.Exact<{
  input: Types.ActivateSizeUomInput;
}>;


export type ActivateSizeUomMutation = { __typename?: 'Mutation', activateSizeUom: { __typename?: 'SizeUomPayload', sizeUom?: { __typename?: 'SizeUomStateData', code: string, description: string, eachesPerUnit: number, status: Types.SizeUomStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeactivateSizeUomMutationVariables = Types.Exact<{
  input: Types.DeactivateSizeUomInput;
}>;


export type DeactivateSizeUomMutation = { __typename?: 'Mutation', deactivateSizeUom: { __typename?: 'SizeUomPayload', sizeUom?: { __typename?: 'SizeUomStateData', code: string, description: string, eachesPerUnit: number, status: Types.SizeUomStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SizeUomStateFragment = { __typename?: 'SizeUomStateData', code: string, description: string, eachesPerUnit: number, status: Types.SizeUomStatus };

export const SizeUomStateFragmentDoc = new TypedDocumentString(`
    fragment SizeUomState on SizeUomStateData {
  code
  description
  eachesPerUnit
  status
}
    `, {"fragmentName":"SizeUomState"});
export const AddSizeUomDocument = new TypedDocumentString(`
    mutation AddSizeUom($input: AddSizeUomInput!) {
  addSizeUom(input: $input) {
    sizeUom {
      ...SizeUomState
    }
    errors {
      code
      message
    }
  }
}
    fragment SizeUomState on SizeUomStateData {
  code
  description
  eachesPerUnit
  status
}`);
export const UpdateSizeUomDocument = new TypedDocumentString(`
    mutation UpdateSizeUom($input: UpdateSizeUomInput!) {
  updateSizeUom(input: $input) {
    sizeUom {
      ...SizeUomState
    }
    errors {
      code
      message
    }
  }
}
    fragment SizeUomState on SizeUomStateData {
  code
  description
  eachesPerUnit
  status
}`);
export const ActivateSizeUomDocument = new TypedDocumentString(`
    mutation ActivateSizeUom($input: ActivateSizeUomInput!) {
  activateSizeUom(input: $input) {
    sizeUom {
      ...SizeUomState
    }
    errors {
      code
      message
    }
  }
}
    fragment SizeUomState on SizeUomStateData {
  code
  description
  eachesPerUnit
  status
}`);
export const DeactivateSizeUomDocument = new TypedDocumentString(`
    mutation DeactivateSizeUom($input: DeactivateSizeUomInput!) {
  deactivateSizeUom(input: $input) {
    sizeUom {
      ...SizeUomState
    }
    errors {
      code
      message
    }
  }
}
    fragment SizeUomState on SizeUomStateData {
  code
  description
  eachesPerUnit
  status
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddSizeUom: build.mutation<AddSizeUomMutation, AddSizeUomMutationVariables>({
      query: (variables) => ({ document: AddSizeUomDocument, variables })
    }),
    UpdateSizeUom: build.mutation<UpdateSizeUomMutation, UpdateSizeUomMutationVariables>({
      query: (variables) => ({ document: UpdateSizeUomDocument, variables })
    }),
    ActivateSizeUom: build.mutation<ActivateSizeUomMutation, ActivateSizeUomMutationVariables>({
      query: (variables) => ({ document: ActivateSizeUomDocument, variables })
    }),
    DeactivateSizeUom: build.mutation<DeactivateSizeUomMutation, DeactivateSizeUomMutationVariables>({
      query: (variables) => ({ document: DeactivateSizeUomDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddSizeUomMutation, useUpdateSizeUomMutation, useActivateSizeUomMutation, useDeactivateSizeUomMutation } = injectedRtkApi;
